import axios from "axios";
import { setupInterceptors } from "./interceptors";
import { AxiosRequestConfig } from "axios";
import { constructAavoHeaders } from "./defaultHeaders";
import { getOrInitSelectedBranchKeyStorage } from "src/storage/appState/branch";
import { getSelectedIdentityStorage } from "src/storage/appState/identitySelection";
import { getOrInitSelectedEnvironmentIdStorage } from "src/storage/appState/environment";

const ApiClient = setupInterceptors(
	axios.create({
		baseURL: window.location.origin,
		headers: {
			"Content-type": "application/json"
		}
	})
);

export const makeAxiosRequest = async <ResponseData>(
	axiosConfig: AxiosRequestConfig = {}
) => {
	const response = await ApiClient.request<ResponseData>({
		...axiosConfig,
		headers: {
			...constructAavoHeaders(
				getOrInitSelectedBranchKeyStorage(),
				getSelectedIdentityStorage(),
				getOrInitSelectedEnvironmentIdStorage()
			),
			...axiosConfig.headers
		}
	});
	return response.data;
};
